module.exports = __webpack_public_path__ + "media/S_Mirage_of_you.df16b439.mp3";